import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef, useEffect } from 'react';
import { useAdition } from '../../../components/Advertising/Adition/useAdition.js';
export const AditionSlot = forwardRef(({
  id,
  ...restProps
}, ref) => {
  const {
    getSlot,
    registerSlot,
    deregisterSlot
  } = useAdition();
  const slot = getSlot(id);
  useEffect(() => {
    registerSlot(id);
    return () => {
      deregisterSlot(id);
    };
  }, [id, registerSlot, deregisterSlot]);
  return _jsx("div", {
    ref: ref,
    id: id,
    style: {
      width: slot?.width,
      height: slot?.height
    },
    ...restProps
  });
});